module.exports = __webpack_public_path__ + "static/media/Rain.bf4ce8a3.svg";